import './dialog.scss'

import { register } from 'tmr/tmr/ngModuleRegistry'

import * as createProductGroupDialog from './createProductGroupDialog/createProductGroupDialog'
import * as debugDialog from './debugDialog/debugDialog'
import * as dialogClose from './dialogClose/dialogClose'
import * as expectedItemsDialog from './expectedItemsDialog/expectedItemsDialog'
import * as itemsByUpcDialog from './itemsByUpcDialog/itemsByUpcDialog'
import * as itemsByUpcStatusDialog from './itemsByUpcStatusDialog/itemsByUpcStatusDialog'
import * as missingItemsDialog from './missingItemsDialog/missingItemsDialog'
import * as newSessionTransferToZoneDialog from './newSessionTransferToZoneDialog/newSessionTransferToZoneDialog'
import * as phaseToPhaseDialog from './phaseToPhaseDialog/phaseToPhaseDialog'
import * as sessionMovementTransferToZoneDialog from './sessionMovementTransferToZoneDialog/sessionMovementTransferToZoneDialog'
import * as sessionTransferToZoneDialog from './sessionTransferToZoneDialog/sessionTransferToZoneDialog'
import * as shippingOperationEntriesDialog from './shippingOperationEntriesDialog/shippingOperationEntriesDialog'
import * as unexpectedItemsDialog from './unexpectedItemsDialog/unexpectedItemsDialog'

export default register(
  'tmr.core.components.dialogs',
  createProductGroupDialog,
  debugDialog,
  dialogClose,
  expectedItemsDialog,
  itemsByUpcDialog,
  itemsByUpcStatusDialog,
  missingItemsDialog,
  newSessionTransferToZoneDialog,
  phaseToPhaseDialog,
  sessionMovementTransferToZoneDialog,
  sessionTransferToZoneDialog,
  shippingOperationEntriesDialog,
  unexpectedItemsDialog
)
